import { useSelectedGamesData } from "entities/modules/stores/useSelectedGamesData";
import { SelectedGame } from "entities/modules/types";
import { OrderedStudio } from "entities/studios/types";
import React, { FC, useEffect, useState } from "react";
import Drawer from "shared/components/Drawer";
import { ArrowBackIcon } from "shared/theme/icons/ArrowBack";
import { useContentScheduleModuleDetails } from "../../../../../../context";
import DrawerSkeleton from "../../../../../../skeleton";
import { StyledPrimaryButton } from "../../../../../ActionButtons/styled";
import SelectedStudioGames from "./SelectedStudioGames";

type Props = {
  studio?: OrderedStudio;
  isOpen: boolean;
  onClose: () => void;
};

const SelectedGamesByStudioDrawer: FC<Props> = ({
  studio,
  isOpen,
  onClose,
}) => {
  const { isLoadingSelectedGamesList } = useContentScheduleModuleDetails();
  const { selectedGames } = useSelectedGamesData();
  const [initialSelectedGames, setInitialSelectedGames] =
    useState<SelectedGame[]>();

  useEffect(() => {
    if (isOpen && !initialSelectedGames) {
      setInitialSelectedGames(selectedGames);
    }

    if (!isOpen) {
      setInitialSelectedGames(undefined);
    }
  }, [initialSelectedGames, isOpen, selectedGames]);

  const isLoading = isLoadingSelectedGamesList || !studio;

  const title = studio?.name || "Studio";

  return (
    <Drawer
      title={title}
      Icon={ArrowBackIcon}
      isOpen={isOpen}
      onCloseDrawer={onClose}
      headingRight={
        <StyledPrimaryButton title="Save" size="small" onClick={onClose} />
      }
    >
      {isLoading && <DrawerSkeleton />}
      {!isLoading && <SelectedStudioGames studio={studio} />}
    </Drawer>
  );
};

export default SelectedGamesByStudioDrawer;
